import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { AuthService } from '../../shared/services/auth.service';
import { filter, map, take } from 'rxjs';

export const PermissionGuard: CanActivateFn = (route) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const requiredPermissions = route.data['permissionsAllowed'] || [];
  const requiredRole = route.data['roleAllowed'] || [];

  return authService.userProfile$.pipe(
    filter(res => res != null),
    take(1),
    map(res => {
    
      const userPermissions = res.userPermissions ?? [];
      const userRoles = res.userRoles ?? [];

      // Check if at least one required permission is present
      const hasPermission = requiredPermissions.some(p =>
        userPermissions.includes(p)
      );

      const filteredRole = userRoles.filter(role =>
        requiredRole.includes(role)
      );

      if (hasPermission || filteredRole.length > 0) {
        return true;
      }

      router.navigate(['/dashboard']);
      return false;
    })
  );

};
